import React, { useState, createContext } from "react";

import CustomizedSnackbars from "../components/alert/Alert";

const AppContext = createContext({});

const AppContextProvider = ({ children }) => {
  const [novoAlerta, setNovoAlerta] = useState(null);
  const [titulo, setTitulo] = useState("");

  const notification = (tipo, msg) => {
    const novoAlerta = {
      type: tipo,
      text: msg,
    };

    setNovoAlerta(novoAlerta);
    setTimeout(() => setNovoAlerta(false), 3000);
  };

  const intitular = (titulo) => {
    setTitulo(titulo ? titulo : "");
  };

  return (
    <AppContext.Provider value={{ notification, intitular, titulo }}>
      {novoAlerta && (
        <CustomizedSnackbars
          texto={novoAlerta.text}
          tipo={novoAlerta.type}
        ></CustomizedSnackbars>
      )}
      {children}
    </AppContext.Provider>
  );
};

export { AppContextProvider };

export default AppContext;
